import React, { useState, useEffect } from "react";
import Container from "../../components/Container";
import { InputPadrao, DatePickerPadrao, BtnPadrao, SemDados, LabelPadrao } from "../../components/Base";
import { Divider, Select, Drawer } from "antd";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import moment from "moment";
import { Radio } from "antd";
import { BarChart, XAxis, Legend, Bar, ResponsiveContainer, Tooltip, Cell, YAxis } from "recharts";
import colors from "../../utils/Colors";
import SelectFiltros from "../../components/SelectFiltros";
import SelectFabricantes from "../../components/SelectFabricantes";
import { connect } from "react-redux";
import { logIn, fetch, setDados } from "../../actions/index";
import culture from "../../utils/Culture";
import SelectEstadosCidades from "../../components/SelectEstadosCidades/SelectEstadosCidades";
import toLocale, { toDecimal } from "../../utils/ToLocaleString"
import DrawerFiltros from "../Shared/DrawerFiltros";

const INITIAL_STATE = { tipo: "par", mesAno: moment(), filtros: "fab" };

function Painel(props) {
  const [filtro, setFiltro] = useState(INITIAL_STATE);
  const [dados, listarDados, loading] = useFetch(() => api.get(props.fetch, filtro));
  const [titulo, setTitulo] = useState("Participação");

  useEffect(() => {
    if (filtro.tipo === "par") setTitulo("Participação (SELL-OUT / FATURAMENTO)");
    if (filtro.tipo === "efi") setTitulo("Eficiência (SELL-OUT / NÚMERO DE VENDAS)");
    if (filtro.tipo === "pen") setTitulo("Penetracão (SELL-OUT / M2)");
  }, [dados])

  // useEffect(() => {
  //   listarDados();
  // }, []);

  useEffect(() => {
    if (filtro.tipo === "par" && filtro.filtro === "loja") {
      setFiltro({ ...filtro, filtro: "fa" });
    }
  }, [filtro.tipo]);

  return (
    <Container loading={loading} path="ranking" large>
      <div style={{ display: "flex", }}>
        <div style={{ width: "20%", marginRight: 20, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "90%" }}>
          <DrawerFiltros filtros={filtro} setFiltros={setFiltro} modelo="caracteristica" />
        </div>
        <div style={{ width: "80%", marginTop: 22 }}>
          <div style={{ display: "flex", alignItems: "center", marginTop: 15, marginBottom: 30 }}>
            <Radio.Group value={filtro.tipo} buttonStyle="solid" onChange={v => setFiltro({ ...filtro, tipo: v.target.value })}>
              <Radio.Button value="par">Participação</Radio.Button>
              <Radio.Button value="efi">Eficiência</Radio.Button>
              <Radio.Button value="pen">Penetracão</Radio.Button>
            </Radio.Group>
            <Select value={filtro.filtros} onChange={v => setFiltro({ ...filtro, filtros: v })} style={{ margin: "0 10px", minWidth: 100 }}>
              {filtro.tipo !== "par" && <Select.Option key="loja">Loja</Select.Option>}
              <Select.Option key="fab">Fabricante</Select.Option>
              {(filtro.setor || []).length && (
                <>
                  <Select.Option key="setgrupo">Setor/Grupo </Select.Option>
                </>
              )}
            </Select>
            <SelectFabricantes style={{ minWidth: 100, marginRight: 10 }} value={filtro.fabricantes} onChange={v => setFiltro({ ...filtro, fabricantes: v })} mode="multiple" maxTagCount={1} />
            <SelectFiltros style={{ minWidth: 100, marginRight: 10 }} modelo="setor" value={filtro.setor} onChange={v => setFiltro({ ...filtro, setor: v })} mode="multiple" maxTagCount={1} placeholder="Setor" />
            <SelectFiltros style={{ minWidth: 100, marginLeft: 10 }} modelo="grupo" value={filtro.grupo} onChange={v => setFiltro({ ...filtro, grupo: v })} mode="multiple" maxTagCount={1} placeholder="Grupo" />
            <DatePickerPadrao picker="month" value={filtro.mesAno} onChange={v => setFiltro({ ...filtro, mesAno: v })} style={{ margin: "0 10px 0 20px" }} allowClear={false} />
            <BtnPadrao onClick={listarDados} type="primary">
              Listar
            </BtnPadrao>
          </div>
          {(dados || []).length ? (
            <>
              {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 0 15px #ddd",
                  borderRadius: 20,
                  padding: 5,
                  height: "calc(100vh - 200px)"
                }}
              >
                <h1 style={{ textAlign: "center", marginTop: 5, color: "#555" }}>{titulo}</h1>
                <Divider style={{ margin: 0 }} />
                <div style={{ height: "100%", flex: 1, padding: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <ResponsiveContainer width="100%" >
                    <BarChart layout="vertical" data={dados} >
                      <XAxis dataKey="valor" hide />
                      <YAxis type="category" width={150} padding={{ left: 20 }} dataKey="nome" />
                      <Tooltip formatter={value => culture.format(value)} />
                      <Bar dataKey="valor" label={{ position: "right", formatter: v => titulo === "Participação (SELL-OUT / FATURAMENTO)" ? toDecimal(v) + "%" : toLocale(v) }}>
                        {(dados || []).map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </>
          ) : (
            <SemDados style={{ marginTop: 60 }} />
          )}</div>
      </div>
    </Container >
  );
}

export default connect(null, { logIn, fetch })(Painel);
